import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=3355d9db&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=3355d9db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355d9db",
  null
  
)

export default component.exports